/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import { ACTION_TYPES } from '../actions/ActionTypes';
import {setItem} from './utils/StorageManager'
import env from '../common/env'

export default class IesAuth {
  constructor(config) {
    this.isInitialized = false;
    this.config = config;
  }

  login(successUrl, storeInfo) {
    const piSession = window.piSession;
    piSession.login(successUrl, 100, (status, accessToken) => {
      if (status === piSession.Success) {
        const userId = piSession.userId();
        if(storeInfo){
            setItem('accessToken', accessToken);
             storeInfo.dispatch({'type': ACTION_TYPES.SET_IES_INFO, 'payload': {'isAuthenticated': true, 'accessToken': accessToken, 'userId': userId}})
        }
         
        //setTimeout(() => { this.login(window.location.href); }, 1*60*1000);
		setTimeout(() => { this.login(env.LAUNDING_URL); }, 1*60*1000);
      } else {
        // something wrong
        piSession.logout();
      }
    });
  }

  logout = () => {
    const piSession = window.piSession;
    if (piSession) {
      piSession.logout();
    }
  };

  /**
   * Load piSession.js script.
   */
  init(storeInfo) {
    if (!this.isInitialized) {
      this.clientId = this.config.CLIENT_ID;
      this.isInitialized = true;
      const script = document.createElement('script');
      script.onload = () => {
        const piSession = window.piSession;
        if (piSession) {
          piSession.initialize(this.clientId, {
            monitorUserActivity: true,
            sessionIdleTimeoutWarningSeconds: 300,//IES session propertis to be updated same as als
            useDefaultIdleTimoutWarningPopup: true,
            requireLogin: true,
            useJwt: true,
            checkSessionMilliseconds: 3600,
            sessionIdleTimeoutSeconds: 3600
          });
          //this.login(window.location.href, storeInfo);
		  this.login(env.LAUNDING_URL, storeInfo);
        }
       // onInit();
      };
      script.src = `${this.config.IES_BASE_URL}/login/js/session.js`;
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  }
}
